// extracted by mini-css-extract-plugin
export default {"container":"CSSContainer_container--Q8D"};